import { FC, useEffect } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import CountrySelect, { BaseCountrySelectProps } from 'components/forms/CountrySelect';
import { CustomerInfoKeyType } from 'types/customer';

export interface IssueCountryFormutil {
    issue_country: string;
}

export const defaultFieldsOfIssueCountry: CustomerInfoKeyType[] = ['issue_country'];

export interface IssueCountryProps extends FormGroupProps {
    isSSN: boolean;
    countrySelectProps?: Omit<BaseCountrySelectProps, 'isSSN'>;
    disabled?: boolean;
    $formutil: $Formutil<IssueCountryFormutil>;
}

/** 证件签发国，目前仅非SSN开户使用 */
const IssueCountry: FC<IssueCountryProps> = ({
    label = __('身份证件签发国家'),
    disabled,
    isSSN,
    $formutil,
    countrySelectProps,
    ...restProps
}) => {
    const { $params, $setValues } = $formutil;
    const { issue_country } = $params;
    const { limitCountryList } = countrySelectProps || {};

    useEffect(() => {
        // 如果签发国列表发生变化且不含当前表单中的签发国，则重置签发国
        if (issue_country && limitCountryList && !limitCountryList.includes(issue_country)) {
            $setValues({
                issue_country: ''
            });
        }
    }, [limitCountryList, issue_country, $setValues]);

    return (
        <FormGroup
            name="issue_country"
            label={label}
            checker={(value: string) => {
                if (disabled) {
                    return true;
                }

                return !!value || __('请选择证件签发国');
            }}
            {...restProps}>
            <CountrySelect isSSN={isSSN} disabled={disabled} fieldName="issue_country" {...countrySelectProps} />
        </FormGroup>
    );
};

export default connect(IssueCountry);
